//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "productDetail",
    components: {},
    data() {
        return {
            id: 0,
            good: {},
            goods: {},
            sku: {
                // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
                // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
                tree: [],
                // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
                list: [],
                price: '', // 默认价格（单位元）
                stock_num: 0, // 商品总库存
                collection_id: 0, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
                none_sku: false, // 是否无规格商品
                hide_stock: false // 是否隐藏剩余库存
            },
            goodsId: 0,
            showSku: false,
            quota: 0, // 限购数(0表示不限购)
            quotaUsed: 1, // 已经购买过的数量
            downloadUrl: util.ApiUrl + '/file/download/',
            content: ''
        }
    },
    methods: {
        onClickIcon() {
            window.location.href = 'tel://400-012-7878'
        },
        onClickCart() {
            // this.$router.push('cart');
        },
        showSkuModal() {
            this.showSku = true;
        },
        getGood() {
            abp.ajax.get('/api/services/app/Good/GetGoodById?id=' + this.id).then(res => {
                this.good = {};
                this.good = res.data.result;
                this.getGoodSpecifiction(this.good.id);
                this.goods.title = this.good.goodName;
                this.goods.picture = this.downloadUrl + this.good.fileName;
                this.sku.stock_num = this.good.totalInventory;
                this.sku.price = this.good.price;
                this.goodsId = this.good.id;
                this.getContent();
            })
        },
        getContent() {
            // if (this.bizId === 0 || !this.bizType) {
            //     return;
            // }
            abp.ajax.get('/api/services/app/GraphicInformation/GetGraphicInformationByBusiness?businessType=' + 'good.content' + '&businessId=' + this.id)
                .then(res => {
                    this.content = res.data.result.content;
                });
        },
        getGoodSpecifiction(id) {
            abp.ajax.get('/api/services/app/GoodSpecification/GetGoodSpecifiction?goodId=' + id)
                .then(res => {
                    // console.log(res.data.result);
                    var r = res.data.result.goodAttributes;
                    var s = [];
                    var i = 0;
                    s = r.map(r => {
                        var l = [];
                        var n = r.goodAttributeDetials;
                        l = n.map(n => {
                            return {
                                id: n.id,
                                name: n.name,
                                imgUrl: this.downloadUrl + this.good.fileName
                            };
                        });
                        i++;
                        return {
                            k: r.name,
                            v: l,
                            k_s: 's' + i
                        };
                    });
                    // console.log('r:%@', r);
                    // console.log('s:%@', s);
                    this.sku.tree = s;

                    var n = res.data.result.goodSpecifications;
                    var m = [];
                    m = n.map(n => {
                        var a = n.goodAttributeDetailId.split(',');
                        return {
                            id: n.id, // skuId，下单时后端需要
                            price: n.price * 100, // 价格（单位分）
                            s1: a[0], // 规格类目 k_s 为 s1 的对应规格值 id
                            s2: a[1], // 规格类目 k_s 为 s2 的对应规格值 id
                            s3: a[2], // 最多包含3个规格值，为0表示不存在该规格
                            stock_num: n.inventory // 当前 sku 组合对应的库存
                        };
                    });
                    // console.log('n:%@', n);
                    // console.log('m:%@', m);
                    this.sku.list = m;
                });
        },
        onBuyClicked() {
            var data = this.$refs.skuref.getSkuData();
            // if (data.selectedSkuComb == null) {
            //     Toast('请选择规格');
            //     return;
            // }
            // console.log('data:%@', data);
            this.$store.commit('saveOrder/isRes', true);
            this.$store.commit('saveOrder/setSkuData', data);
            this.$router.push({path: '/save-order'})
        },
        onAddCartClicked() {
        },
        onSavePointMall() {
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getGood();
        }

    }
};
